import { DiscountedInstallmentsLine } from "./DiscountedInstallmentsLine";
import { StandardInstallmentsLine } from "./StandardInstallmentsLine";
import { TitleLine } from "./TitleLine";

export const InstallmentsLines = Object.assign(
  {},
  {
    TitleLine,
    StandardInstallmentsLine,
    DiscountedInstallmentsLine,
  },
);
